module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"compareProducts":"Compare Products","compare":"Compare ({count}-4)","viewComparison":"View Comparison","clear":"Remove Products"},"ar":{"compareProducts":"قارن المنتجات","compare":"قارن المنتجات ({0}-٤)","viewComparison":"عرض المقارنة","clear":"مسح المنتجات"}}')
  delete Component.options._Ctor
}
